import React from 'react'

import { SpinnerWrapper } from './styles'

const Spinner: React.FC = () => <SpinnerWrapper />

export default Spinner
